import { render, staticRenderFns } from "./SingleBoard.vue?vue&type=template&id=9f7196e2&scoped=true&"
import script from "./SingleBoard.vue?vue&type=script&lang=js&"
export * from "./SingleBoard.vue?vue&type=script&lang=js&"
import style0 from "./SingleBoard.vue?vue&type=style&index=0&id=9f7196e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7196e2",
  null
  
)

export default component.exports